import { withRouter } from 'react-router-dom';
import GenericErrorPage from './generic-error-page';

const UnauthorizedError = () => (
  <GenericErrorPage
    code='401'
    description='UNAUTHORIZED'
    message='You are not authorized to view this page.'
  />
);

export default withRouter(UnauthorizedError);
